import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('disability_benefits_set', '/disability_benefits_sets', 'benefits_set')
const reducer = generator.generate()

export default reducer
